import { useQuery } from "react-query";
import { getUserById, getUsers } from "../services/user/getUsers";
import { PagedRequestType } from "../types/PagedResults";

export const useGetUsersQuery = (data: PagedRequestType) =>
  useQuery(
    ["users-pagination", JSON.stringify(data)],
    () => getUsers(data)
  );

  export const useGetUserByIdQuery = (id: string, isEnabled:boolean = false) =>
    useQuery(
      ["userById-pagination", JSON.stringify(id)],
      () => getUserById(id), 
      { enabled:isEnabled }
    );